import React, {Component} from 'react'
import PropTypes from 'prop-types'
import Dropzone from 'react-dropzone'
import firebase from '../firebase'
import * as helpers from '../lib/HelperFunctions'
import {Glyphicon, ProgressBar, Button} from 'react-bootstrap'
import FaFileO from 'react-icons/lib/fa/file-o'
import FaFileImageO from 'react-icons/lib/fa/file-image-o'
import FaFileMovieO from 'react-icons/lib/fa/file-movie-o'
import FaFilePdfO from 'react-icons/lib/fa/file-pdf-o'
import FaFileExcelO from 'react-icons/lib/fa/file-excel-o'
import FaFileWordO from 'react-icons/lib/fa/file-word-o'
import FaFilePowerpointO from 'react-icons/lib/fa/file-powerpoint-o'
import FaFileArchiveO from 'react-icons/lib/fa/file-archive-o'
import FaFileCodeO from 'react-icons/lib/fa/file-code-o'
import FaFileTextO from 'react-icons/lib/fa/file-text-o'
import './css/IdeaImageField.css'
import Logger from '../stores/Logger'

class IdeaAttachmentField extends Component {
    constructor(props) {
        super(props)
        this.onDropAccepted = this.onDropAccepted.bind(this)
        this.onDropRejected = this.onDropRejected.bind(this)
        this.state = {
            ideaAttachmentIsUploading: false,
            shouldSetState: true,
            ideaAttachmentProgress: 0,
            ideaContentType: 'application/octet-stream',
            ideaAttachmentTotalBytes: 0,
        }
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.attachmentUrl){
            if (this.state.shouldSetState){
                if(nextProps.attachmentUrl.indexOf('https://firebasestorage.googleapis.com')>-1){
                    firebase.storage().refFromURL(nextProps.attachmentUrl).getMetadata().then(metadata => {
                        // console.log(metadata)
                        // Metadata now contains the metadata for 'images/forest.jpg'
                        this.getData(metadata)
                    }).catch(function (error) {
                        console.error('Error getting attachment metadata:',error)
                        // Uh-oh, an error occurred!
                    })
                }else{
                    //duplicated files are are on https://storage.googleapis.com, not firebasestorage., and then the firebase.refFromURL fails
                    // No biggie    
                }
            }
        }
    }

    getData(metadata){
        if (this.state.shouldSetState){
            this.setState({ideaContentType: metadata.contentType})
        }
    }

    componentWillUnmount(){
        this.setState({shouldSetState: false})
    }

    onDropRejected(files) {
        console.error(files,'rejected!')
        this.props.onAttachmentRejected(files[0])
    }
    onDropAccepted(files) {
        if(files.length===0)
            return

        var uploadTask = firebase.storage().ref('ideas/ideasheet/attachments').child(helpers.guid()).child(files[0].name).put(files[0])
        // Listen for state changes, errors, and completion of the upload.
        uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
        (snapshot) => {
            // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
            var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
            // console.log('Upload is ' + progress + '% done')
            this.setState({
                ideaAttachmentProgress: progress,
                ideaAttachmentTotalBytes: snapshot.totalBytes,
            })
            switch (snapshot.state) {
                case firebase.storage.TaskState.PAUSED: // or 'paused'
                    console.log('Upload is paused')
                    break
                case firebase.storage.TaskState.RUNNING: // or 'running'
                    this.setState({
                        ideaAttachmentIsUploading:true,
                    })
                    // console.log('Upload is running')
                    break

                default:
                    break

            }
        }, (error) => {
            Logger.trackEvent('attachmentUploadFailed', 'error', error)
            console.error(error)
            this.onDropRejected(files)
            this.setState({
                ideaAttachmentIsUploading: false,
            })
            // //A full list of error codes is available at
            // // https://firebase.google.com/docs/storage/web/handle-errors
            // switch (error.code) {
            //     case 'storage/unauthorized':
            //     // User doesn't have permission to access the object
            //     break

            //     case 'storage/canceled':
            //     // User canceled the upload
            //     break

            //     case 'storage/unknown':
            //     // Unknown error occurred, inspect error.serverResponse
            //     break

            //     default:
            //     break
            // }
        }, () => {
            // Upload completed successfully
            Logger.trackEvent('attachmentUploaded', 'size', this.state.ideaAttachmentTotalBytes)
            this.setState({
                ideaAttachmentIsUploading: false,
                ideaAttachmentProgress: 100,
                ideaAttachmentTotalBytes: 0,
            })
            this.props.onNewAttachment(uploadTask.snapshot.downloadURL, uploadTask.snapshot.ref.bucket, uploadTask.snapshot.ref.fullPath, files[0].name, this.props.theKey)
        })
    }

    fileIcon(contentType){
        if(!contentType){
            return <FaFileO size={100+'%'}/>
        }
        let found = false
        //first search for specific types
        switch (contentType) {
            case 'application/pdf':
                return <FaFilePdfO size={100+'%'}/>
            case 'application/x-compressed':
            case 'application/x-zip-compressed':
            case 'application/zip':
            case 'application/x-gzip':
            case 'multipart/x-gzip':
            case 'application/x-tar':
            case 'application/x-bzip2':
                return <FaFileArchiveO size={100+'%'}/>
            case 'application/x-excel':
            case 'application/x-msexcel':
            case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
            case 'application/vnd.openxmlformats-officedocument.spreadsheetml.template':
                return <FaFileExcelO size={100+'%'}/>
            case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
            case 'application/vnd.openxmlformats-officedocument.wordprocessingml.template':
            case 'application/msword':
                return <FaFileWordO size={100+'%'}/>
            case 'application/vnd.ms-powerpoint':
            case 'application/vnd.openxmlformats-officedocument.presentationml.template':
            case 'application/vnd.openxmlformats-officedocument.presentationml.slideshow':
            case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
                return <FaFilePowerpointO size={100+'%'}/>
            case 'application/xml':
            case 'application/octet-stream':
            case 'application/x-javascript':
            case 'application/java-archive':
            case 'application/json':
            case 'text/javascript':
            case 'text/x-javascript':
            case 'text/x-json':
                return <FaFileCodeO size={100+'%'}/>
            default:
                found = false
                break
        }
        //...if no specific types found, then search on first part
        if(!found){
            let majorType = contentType.split("/")[0]
            switch (majorType) {
                case 'image':
                    return <FaFileImageO size={100+'%'}/>
                case 'video':
                    return <FaFileMovieO size={100+'%'}/>
                case 'text':
                    return <FaFileTextO size={100+'%'}/>

                default:
                    return <FaFileO size={100+'%'}/>
            }
        }
    }

    render(){
        let tpe = this.state.ideaContentType
        let fileIcon = this.fileIcon(tpe)
        let origFileName = this.props.origFileName || 'Download file'      
        return (
            <div ref='dropzone'>
            {this.props.showDropzone === true &&
            <div>
            {this.state.ideaAttachmentIsUploading &&
                <ProgressBar active now={this.state.ideaAttachmentProgress} className='attachmentProgressBar' />
            }
           
            <Dropzone
                onDropAccepted={this.onDropAccepted}
                onDropRejected={this.onDropRejected}
                disablePreview={true}
                multiple={false}
                // maxSize={10000000} 
                className='predo-attachment'
                activeClassName='predo-imagefield accepted'
                rejectClassName='predo-imagefield rejected'
            >
                {this.props.attachmentUrl ? (
                    <div>{fileIcon}</div>
                ):(
                    <div>
                        <p className='dragImageText' style={{padding: 20, marginTop: 10+'px', textAlign:'center'}}>
                            <Glyphicon glyph='download-alt' className='imageDropZoneText' style={{fontSize:60}}/><br/>
                            Choose an file or drag it here
                        </p>
                    </div>
                )}
            </Dropzone>
            {this.props.attachmentUrl && (
                <p className='attachmentName'><a href={this.props.attachmentUrl} target='_blank' rel='noopener noreferrer'><em title={origFileName}>{origFileName}</em></a></p>
            )}
            {this.props.attachmentUrl &&
             <Button className='attachmentFieldTrashButton' onClick={() => this.props.handleAttachmentDelete(this.props.theKey)}><Glyphicon className='attachmentTrashIcon' glyph='trash'/></Button>
            }
            </div>
            }
            {this.props.showDropzone === false &&
                <div>
                    <div>{fileIcon}</div>
                    {this.props.attachmentUrl && (
                        <p className='attachmentNameView'><a href={this.props.attachmentUrl} target='_blank' rel='noopener noreferrer'><em title={origFileName}>{origFileName}</em></a></p>
                    )}
                </div>
            }
            </div>
        )
    }
}
IdeaAttachmentField.propTypes = {
    attachmentUrl: PropTypes.string,
    origFileName: PropTypes.string,
    onNewAttachment: PropTypes.func.isRequired,
    onAttachmentRejected: PropTypes.func.isRequired,
    theKey: PropTypes.number,
    showDropzone: PropTypes.bool.isRequired,
}

export default IdeaAttachmentField



// WEBPACK FOOTER //
// ./src/components/IdeaAttachmentField.js